import { render, staticRenderFns } from "./RequestForm.vue?vue&type=template&id=afdf6182&scoped=true&"
import script from "./RequestForm.vue?vue&type=script&lang=js&"
export * from "./RequestForm.vue?vue&type=script&lang=js&"
import style0 from "./RequestForm.vue?vue&type=style&index=0&id=afdf6182&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afdf6182",
  null
  
)

export default component.exports